import { Divider, Grid, Typography } from "@mui/material";

import PropTypes from "prop-types";

MissionProtocolStageTableLiteral.propTypes = {
    TGDTSortedByDatatype: PropTypes.object.isRequired,
};

export function MissionProtocolStageTableLiteral({ TGDTSortedByDatatype }) {
    return (
        <Grid container spacing={2}>
            {Object.entries(TGDTSortedByDatatype).map(
                ([dataType, traitGroupDataTypes]) => (
                    <Grid key={dataType} container spacing={0.5}>
                        <Grid size={12}>
                            <Typography
                                sx={{ fontStyle: "italic", color: "grey" }}
                            >
                                <strong>{`Selected traits (${dataType})`}</strong>
                            </Typography>
                            <Divider />
                        </Grid>

                        {traitGroupDataTypes.map((TGDT) => (
                            <Grid key={TGDT.uuid} size={12}>
                                <Typography>{TGDT.TraitGroup.name}</Typography>
                            </Grid>
                        ))}
                    </Grid>
                )
            )}
        </Grid>
    );
}
